import { render, staticRenderFns } from "./judgeHistory.vue?vue&type=template&id=13d06b0c&scoped=true"
import script from "./judgeHistory.vue?vue&type=script&lang=js"
export * from "./judgeHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d06b0c",
  null
  
)

export default component.exports